import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { RecruitmentAgenciesType } from '../Actions'
import {
  ACCEPT_EMAIL_INVITATION,
  GET_AGENCIES_DETAIL,
  GET_AVERAGE_TIME_TO_FILL_DATA,
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA,
  GET_OVERALL_SUBMISSION_STATS_DATA,
  GET_RECRUITMENT_ACTIVE_JD_LIST,
  GET_RECRUITMENT_AGENCIES_LIST,
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL,
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST,
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST,
  GET_SUBMISSION_TRACK_DATA,
  RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE,
} from '../constants/action-types'

const initialState = {
  isLoadingAgenciesList: false,
  agenciesList: [],
  isLoadingAllAgencyDetail: false,
  allAgencyDetail: {},
  isLoadingRecruitmentAgencyList: false,
  recruitmentAgencyList: [],
  isLoadingRecruitmentAgencyDetail: false,
  recruitmentAgencyDetail: {},
  isLoadingRecruitmentAcceptDecline: false,
  isLoadingEmailInvitation: false,
  isLoadingRecruitmentActiveJDList: false,
  recruitmentActiveJDList: [],
  isLoadingSharedCandidateList: false,
  SharedCandidateList: [],
  averageTimeToFillData: [],
  isLoadingAverageTimeToFillData: false,
  candidateQualityDistributionData: [],
  isLoadingcandidateQualityDistributionData: false,
  submissionTrackData: [],
  isLoadingSubmissionTrackData: false,
  overallSubmissionStatsData: {},
  isLoadingOverallSubmissionStatsData: false,
}

const recruitmentAgenciesReducer = persistReducer(
  { storage, key: 'recruitment-agencies', whitelist: [] },
  (state: RecruitmentAgenciesType = initialState, action: ActionTypes) => {
    switch (action.type) {
      // Recruitment Agency List
      case GET_RECRUITMENT_AGENCIES_LIST.GET_RECRUITMENT_AGENCIES_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoadingAgenciesList: true,
        }

      case GET_RECRUITMENT_AGENCIES_LIST.GET_RECRUITMENT_AGENCIES_LIST_SUCCESS:
        return {
          ...state,
          agenciesList: action.payload,
          isLoadingAgenciesList: false,
        }

      case GET_RECRUITMENT_AGENCIES_LIST.GET_RECRUITMENT_AGENCIES_LIST_ERROR:
        return {
          ...state,
          errorMessage: '',
          isLoadingAgenciesList: false,
        }

      case GET_AGENCIES_DETAIL.GET_AGENCIES_DETAIL_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoadingAllAgencyDetail: true,
        }

      case GET_AGENCIES_DETAIL.GET_AGENCIES_DETAIL_SUCCESS:
        return {
          ...state,
          allAgencyDetail: action.payload,
          isLoadingAllAgencyDetail: false,
        }

      case GET_AGENCIES_DETAIL.GET_AGENCIES_DETAIL_ERROR:
        return {
          ...state,
          errorMessage: '',
          isLoadingAllAgencyDetail: false,
        }

      case GET_RECRUITMENT_AGENCIES_REQUEST_LIST.GET_RECRUITMENT_AGENCIES_REQUEST_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoadingRecruitmentAgencyList: true,
        }

      case GET_RECRUITMENT_AGENCIES_REQUEST_LIST.GET_RECRUITMENT_AGENCIES_REQUEST_LIST_SUCCESS:
        return {
          ...state,
          recruitmentAgencyList: action.payload,
          isLoadingRecruitmentAgencyList: false,
        }

      case GET_RECRUITMENT_AGENCIES_REQUEST_LIST.GET_RECRUITMENT_AGENCIES_REQUEST_LIST_ERROR:
        return {
          ...state,
          errorMessage: '',
          isLoadingRecruitmentAgencyList: false,
        }

      case GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL.GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoadingRecruitmentAgencyDetail: true,
        }

      case GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL.GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_SUCCESS:
        return {
          ...state,
          recruitmentAgencyDetail: action.payload,
          isLoadingRecruitmentAgencyDetail: false,
        }

      case GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL.GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_ERROR:
        return {
          ...state,
          errorMessage: '',
          isLoadingRecruitmentAgencyDetail: false,
        }
      case RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE.RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_INITIALIZATION:
        return {
          ...state,
          isLoadingRecruitmentAcceptDecline: true,
        }

      case RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE.RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_SUCCESS:
        return {
          ...state,
          isLoadingRecruitmentAcceptDecline: false,
        }

      case RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE.RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_ERROR:
        return {
          ...state,
          isLoadingRecruitmentAcceptDecline: false,
        }

      case ACCEPT_EMAIL_INVITATION.ACCEPT_EMAIL_INVITATION_INITIALIZATION:
        return {
          ...state,
          isLoadingEmailInvitation: true,
        }

      case ACCEPT_EMAIL_INVITATION.ACCEPT_EMAIL_INVITATION_SUCCESS:
        return {
          ...state,
          isLoadingEmailInvitation: false,
        }

      case ACCEPT_EMAIL_INVITATION.ACCEPT_EMAIL_INVITATION_ERROR:
        return {
          ...state,
          isLoadingEmailInvitation: false,
        }

      case GET_RECRUITMENT_ACTIVE_JD_LIST.GET_RECRUITMENT_ACTIVE_JD_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingRecruitmentActiveJDList: true,
        }

      case GET_RECRUITMENT_ACTIVE_JD_LIST.GET_RECRUITMENT_ACTIVE_JD_LIST_SUCCESS:
        return {
          ...state,
          recruitmentActiveJDList: action.payload,
          isLoadingRecruitmentActiveJDList: false,
        }

      case GET_RECRUITMENT_ACTIVE_JD_LIST.GET_RECRUITMENT_ACTIVE_JD_LIST_FAILED:
        return {
          ...state,
          isLoadingRecruitmentActiveJDList: false,
        }

      case GET_RECRUITMENT_SHARED_CANDIDATE_LIST.GET_RECRUITMENT_SHARED_CANDIDATE_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingSharedCandidateList: true,
        }

      case GET_RECRUITMENT_SHARED_CANDIDATE_LIST.GET_RECRUITMENT_SHARED_CANDIDATE_LIST_SUCCESS:
        return {
          ...state,
          SharedCandidateList: action.payload,
          isLoadingSharedCandidateList: false,
        }

      case GET_RECRUITMENT_SHARED_CANDIDATE_LIST.GET_RECRUITMENT_SHARED_CANDIDATE_LIST_FAILED:
        return {
          ...state,
          isLoadingSharedCandidateList: false,
        }

      case GET_AVERAGE_TIME_TO_FILL_DATA.GET_AVERAGE_TIME_TO_FILL_DATA_INITIALIZATION:
        return {
          ...state,
          isLoadingAverageTimeToFillData: true,
        }

      case GET_AVERAGE_TIME_TO_FILL_DATA.GET_AVERAGE_TIME_TO_FILL_DATA_SUCCESS:
        return {
          ...state,
          averageTimeToFillData: action.payload,
          isLoadingAverageTimeToFillData: false,
        }

      case GET_AVERAGE_TIME_TO_FILL_DATA.GET_AVERAGE_TIME_TO_FILL_DATA_FAILED:
        return {
          ...state,
          isLoadingAverageTimeToFillData: false,
        }
      case GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA.GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_INITIALIZATION:
        return {
          ...state,
          isLoadingcandidateQualityDistributionData: true,
        }

      case GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA.GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_SUCCESS:
        return {
          ...state,
          candidateQualityDistributionData: action.payload,
          isLoadingcandidateQualityDistributionData: false,
        }

      case GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA.GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_FAILED:
        return {
          ...state,
          isLoadingcandidateQualityDistributionData: false,
        }

      case GET_SUBMISSION_TRACK_DATA.GET_SUBMISSION_TRACK_DATA_INITIALIZATION:
        return {
          ...state,
          isLoadingSubmissionTrackData: true,
        }

      case GET_SUBMISSION_TRACK_DATA.GET_SUBMISSION_TRACK_DATA_SUCCESS:
        return {
          ...state,
          submissionTrackData: action.payload,
          isLoadingSubmissionTrackData: false,
        }

      case GET_SUBMISSION_TRACK_DATA.GET_SUBMISSION_TRACK_DATA_FAILED:
        return {
          ...state,
          isLoadingSubmissionTrackData: false,
        }

      case GET_OVERALL_SUBMISSION_STATS_DATA.GET_OVERALL_SUBMISSION_STATS_DATA_INITIALIZATION:
        return {
          ...state,
          isLoadingOverallSubmissionStatsData: true,
        }

      case GET_OVERALL_SUBMISSION_STATS_DATA.GET_OVERALL_SUBMISSION_STATS_DATA_SUCCESS:
        return {
          ...state,
          overallSubmissionStatsData: action.payload,
          isLoadingOverallSubmissionStatsData: false,
        }

      case GET_OVERALL_SUBMISSION_STATS_DATA.GET_OVERALL_SUBMISSION_STATS_DATA_FAILED:
        return {
          ...state,
          isLoadingOverallSubmissionStatsData: false,
        }

      default:
        return state
    }
  }
)

export default recruitmentAgenciesReducer
